import HttpService from './baseHttp'
//其他入库分页查询
export const HttpMiscInboundList = (data) => HttpService.get('/api/v2/MiscInboundOrder/findByPage', { params: data, baseURL:  process.env.VUE_APP_APIURL_FBB });
//取消
export const HttpCancelMiscInbound = (data) => HttpService.post('/api/v2/MiscInboundOrder/cancel', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//确认
export const HttpSureMiscInbound = (data) => HttpService.post('/api/v2/MiscInboundOrder/sure', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//详情
export const HttpMiscInbound = (data) => HttpService.post('/api/v2/MiscInboundOrder/detail', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//添加明细时sku弹框选择
export const HttpMiscInboundErpSku = (data = {}) => HttpService.get("/api/v1/Product/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });
//获取当前管理组织管理及所选客户有权限的组织仓
export const HttpHostAndCustomerWarehouse = (data = {}) => HttpService.post("/api/v2/customerRate/getHostAndCustomerWarehouse", data, { baseURL: process.env.VUE_APP_APIURL_FBB});
//添加
export const HttpAddMiscInbound = (data) => HttpService.post('/api/v2/MiscInboundOrder/create', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB});
//修改
export const HttpUpdateMiscInbound = (data) => HttpService.post('/api/v2/MiscInboundOrder/update', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB });
//导出
export const HttpExportMiscInbound = (data, config) => HttpService.get("/api/v2/MiscInboundOrder/batchExport", {params: data, ...config,  baseURL: process.env.VUE_APP_APIURL_FBB });

//其他出库分页查询
export const HttpMiscOutboundList = (data) => HttpService.get('/api/v2/MiscOutboundOrder/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//取消
export const HttpCancelMiscOutbound = (data) => HttpService.post('/api/v2/MiscOutboundOrder/cancel', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//确认
export const HttpSureMiscOutbound = (data) => HttpService.post('/api/v2/MiscOutboundOrder/sure', data, { baseURL:process.env.VUE_APP_APIURL_FBB });
//详情
export const HttpMiscOutbound = (data) => HttpService.post('/api/v2/MiscOutboundOrder/detail', data, { baseURL: process.env.VUE_APP_APIURL_FBB});
//添加
export const HttpAddMiscOutbound = (data) => HttpService.post('/api/v2/MiscOutboundOrder/create', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB });
//修改
export const HttpUpdateMiscOutbound = (data) => HttpService.post('/api/v2/MiscOutboundOrder/update', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB });
//查询库存量
export const HttpMiscOutboundErpSku = (data = {}) => HttpService.get("/api/v1/Product/findInventoryByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS  });

//保存并确认
export const HttpSaveAndSureMiscOutbound = (data) => HttpService.post('/api/v2/MiscOutboundOrder/saveAndSure', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB });
//保存并确认
export const HttpSaveAndSureMiscInbound = (data) => HttpService.post('/api/v2/MiscInboundOrder/saveAndSure', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB });
//导出
export const HttpExportMiscOutbound = (data, config) => HttpService.get("/api/v2/MiscOutboundOrder/batchExport", {params: data, ...config,  baseURL: process.env.VUE_APP_APIURL_FBB });

// 换标上架计划客户端列表
export const HttpMarkChangeCustomList = (data) => HttpService.post('/api/v2/changeLabelPlan/findByPage', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 换标上架计划管理端列表
export const HttpMarkChangeManageList = (data) => HttpService.post('/api/v2/changeLabelPlan/findByPageManage', data ,{ baseURL:  process.env.VUE_APP_APIURL_FBB });
// 换标上架计划管理端列表
export const HttpMarkChangeListCount = (data) => HttpService.post('/api/v2/changeLabelPlan/getCountByStatus', data ,{ baseURL:  process.env.VUE_APP_APIURL_FBB });
// 换标上架计划查看
export const HttpMarkChangeDetail = (data) => HttpService.post('/api/v2/changeLabelPlan/detail', data, { baseURL:  process.env.VUE_APP_APIURL_FBB });
// 换标上架计划创建
export const HttpMarkChangeSave = (data) => HttpService.post('/api/v2/changeLabelPlan/saveOne', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB });
// 换标上架计划保存并提交
export const HttpMarkSaveAndSubmit = (data) => HttpService.post('/api/v2/changeLabelPlan/saveAndSubmit', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB });
// 换标上架计划提交审核
export const HttpMarkChangeSubmit = (data) => HttpService.post('/api/v2/changeLabelPlan/submit', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 换标上架计划撤销审核
export const HttpMarkChangeRevokeExamine = (data) => HttpService.post('/api/v2/changeLabelPlan/revokeApply', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 换标上架计划审核
export const HttpMarkChangeExamine = (data) => HttpService.post('/api/v2/changeLabelPlan/check', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 换标上架计划完成
export const HttpMarkChangeComplete = (data) => HttpService.post('/api/v2/changeLabelPlan/complete', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 换标上架计划取消
export const HttpMarkChangeCancel = (data) => HttpService.post('/api/v2/changeLabelPlan/cancel', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 换标上架计划重推仓库
export const HttpMarkRepushWarehouse = (data) => HttpService.post('/api/v2/changeLabelPlan/repushWarehouse', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 上传附件
export const HttpMarkChangeUploadAttach = (data) => HttpService.post('/api/v2/changeLabelPlan/attachmentUpload', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 删除附件
export const HttpMarkChangeDeleteAttach = (data) => HttpService.post('/api/v2/changeLabelPlan/deleteAttachments', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 换标上架计划上传SKU
export const HttpUploadSku = (data) => HttpService.post('/api/v2/changeLabelPlan/importItem', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 换标上架单列表
export const HttpMarkChangeOrderList = (data) => HttpService.post('/api/v2/changeLabelInbound/findByPageManage', data, { baseURL:  process.env.VUE_APP_APIURL_FBB });
// 换标上架单查看
export const HttpMarkChangeOrderDetail = (data) => HttpService.post('/api/v2/changeLabelInbound/detail', data, { baseURL:  process.env.VUE_APP_APIURL_FBB });
// 换标上架单创建
export const HttpMarkChangeOrderSave = (data) => HttpService.post('/api/v2/changeLabelInbound/saveOne', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB });
// 换标上架单确认
export const HttpMarkChangeOrderConfirm = (data) => HttpService.post('/api/v2/changeLabelInbound/sure', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 换标上架单取消
export const HttpMarkChangeOrderCancel = (data) => HttpService.post('/api/v2/changeLabelInbound/cancell', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 换标下架单列表
export const HttpMarkChangeOrderOutList = (data) => HttpService.post('/api/v2/changeLabelOutbound/findByPageManage', data, { baseURL:  process.env.VUE_APP_APIURL_FBB });
// 换标下架单查看
export const HttpMarkChangeOrderOutDetail = (data) => HttpService.post('/api/v2/changeLabelOutbound/detail', data, { baseURL:  process.env.VUE_APP_APIURL_FBB });
// 换标下架单创建
export const HttpMarkChangeOrderOutSave = (data) => HttpService.post('/api/v2/changeLabelOutbound/saveOne', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB });
// 换标下架单确认
export const HttpMarkChangeOrderOutConfirm = (data) => HttpService.post('/api/v2/changeLabelOutbound/sure', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 换标下架单取消
export const HttpMarkChangeOrderOutCancel = (data) => HttpService.post('/api/v2/changeLabelOutbound/cancel', data, { baseURL: process.env.VUE_APP_APIURL_FBB });


// 获取亚马逊仓地址code
export const HttpWareHouseCodeList = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/findWareHouseCode', { params: data, baseURL:  process.env.VUE_APP_APIURL_BOSS })
// 通过仓库id，获取仓库地址信息
export const HttpAllotAddress = (data = {}, config) => HttpService.get('/api/v2/AmazonAllocation/findByOrgIdAndCode', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS  })
// 调拨创建
export const HttpTransferPlanCreate = (data) => HttpService.post('/api/v2/TransferOutboundPlan/createNew', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB });
// 调拨更新
export const HttpTransferPlanUpdate = (data) => HttpService.post('/api/v2/TransferOutboundPlan/updateNew', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB });
// 卡车预约
export const HttpCreateTruck = (data) => HttpService.post('/api/v2/TransferOutboundPlan/addTruckReserve', data, { baseURL: process.env.VUE_APP_APIURL_FBB });


// 测算弹框列表
export const HttpGetCalculateList = (data) => HttpService.get('/api/v2/TransferOutboundPlan/calculate', { params: data, baseURL:  process.env.VUE_APP_APIURL_FBB });

// 调拨购买面单
export const HttpGetBuyLable = (data) => HttpService.get('/api/v2/TransferOutboundPlan/buyLable', { params: data, baseURL:  process.env.VUE_APP_APIURL_FBB });

